import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OrganizerState {
  accessToken: string;
}

const initialState: OrganizerState = {
  accessToken: "",
};

const OrganizerSlice = createSlice({
  name: "organizer",
  initialState,
  reducers: {
    loginOrganizer(
      state,
      action: PayloadAction<{ accessToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
    },
    logoutOrganizer(state) {
      state.accessToken = "";
    },
  },
});

export const { loginOrganizer, logoutOrganizer } = OrganizerSlice.actions;
export default OrganizerSlice.reducer;
